import { ComputeGeocode, GeocodeToken } from "$src/application/map/commands/ComputeGeocode";
import { AddressValue } from "$src/domain/core/AddressValue";
import { Geocode } from "$src/domain/map/GeoCode";
import { useMutation } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function computeGeocode(address: AddressValue)
    : Promise<Geocode> {

    const query = container.resolve<ComputeGeocode>(GeocodeToken);
    return query.execute(address);
}

export function useComputeGeocode() {
    return useMutation(
        ({ address }: 
            { address: AddressValue }
        ) => computeGeocode(address)
    );
}